import { FC } from "react";
import "./ScheduleStopListItem.scss";
import { ReactComponent as CargoShip } from "assets/images/iconsV2/cargo-ship.svg";
import { ReactComponent as Plane } from "assets/images/iconsV2/plane-grey.svg";

type ScheduleStopListItemProps = {
  dateTime: string;
  transportLocationName: string;
  isAirFreight: boolean;
  carrierName?: string;
  showLine?: boolean;
};

const ScheduleStopListItem: FC<ScheduleStopListItemProps> = function (props) {
  const { dateTime, transportLocationName, isAirFreight, carrierName, showLine } = props;
  return (
    <div className="schedule-stop-item">
      <div className={`schedule-stop-item__timeline ${showLine ? "schedule-stop-item__timeline-line" : ""}`}>
        <div className="schedule-stop-item__circle" />
      </div>
      <div>
        <div className="text-secondary text-xs">{dateTime}</div>
        <div className="text-primary text-sm font-medium">{transportLocationName}</div>
        {carrierName && (
          <div className="schedule-stop-item__flight-detail">
            {carrierName && <>{isAirFreight ? <Plane /> : <CargoShip />}</>}
            <div className="text-xs text-tertiary mx-sm">{carrierName}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScheduleStopListItem;

ScheduleStopListItem.defaultProps = {
  showLine: true,
  carrierName: undefined,
};
